// extracted by mini-css-extract-plugin
export default {"hero":"ZWH4KEN2","backgroundImg":"EJ6zPyAJ","heroContent":"AfLcEVzM","heroHeader":"nslzJJq_","heroContentText":"pV5GyYUZ","heroButton":"T3S4429m","heroImage":"ptYoCJ0m"};